export let hress3uColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRESS3UC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 120px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRESS3UC1',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRESS3UC1',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRESS3UC1',
      labelIndex: '55',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRESS3UC1',
      labelIndex: '60',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRESS3UC1',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRESS3UC1',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRESS3UC1',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRESS3UC1',
      labelIndex: '100',
      style: 'min-width: 200px;'
    }
  ]
  let tab1TableColumns = [
    {
      key: 'codpolicy',
      name: '',
      labelCodapp: 'HRESS3UC3',
      labelIndex: '160',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codpolicy',
      name: '',
      labelCodapp: 'HRESS3UC3',
      labelIndex: '170',
      style: 'min-width: 300px;'
    }, {
      key: 'qtycompst',
      name: '',
      labelCodapp: 'HRESS3UC3',
      labelIndex: '180',
      class: 'align-center',
      style: 'min-width: 150px;',
      summary: true
    }
  ]
  let tab2TableColumns = [
    {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRESS3UC4',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'nampfic',
      name: '',
      labelCodapp: 'HRESS3UC4',
      labelIndex: '30',
      style: 'min-width: 200px;'
    }, {
      key: 'adrpfic',
      name: '',
      labelCodapp: 'HRESS3UC4',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'desrel',
      name: '',
      labelCodapp: 'HRESS3UC4',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;'
    }, {
      key: 'ratepf',
      name: '',
      labelCodapp: 'HRESS3UC4',
      labelIndex: '60',
      class: 'align-right',
      style: 'min-width: 120px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      columnsTab1: tab1TableColumns,
      columnsTab2: tab2TableColumns
    },
    th: {
      index: indexColumns,
      columnsTab1: tab1TableColumns,
      columnsTab2: tab2TableColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hress3u.js